import { CommonModule, DatePipe, Location } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatStepper, MatStepperModule } from "@angular/material/stepper";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import {
  MatProgressSpinnerModule,
  MatSpinner,
} from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { FileUploadModule } from "@iplab/ngx-file-upload";
import moment from "moment";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { NgxMaskDirective } from "ngx-mask";
import { ToastrService } from "ngx-toastr";
import {
  distinctUntilChanged,
  filter,
  forkJoin,
  Subscription,
  tap,
} from "rxjs";
import { CustomizerSettingsService } from "../../../customizer-settings/customizer-settings.service";
import { ApplicationService } from "../../../services/application.service";
import { FormService } from "../../../services/form.service";
import { ClassDays, CoursesInterface } from "../../../services/Interfaces";
import { PasswordValidatorService } from "../../../services/password-validator.service";
import { SweetAlertService } from "../../../services/sweet-alert.service";
import { DatePickerComponent } from "../date-picker/date-picker.component";
import { NgAutocompleteComponent } from "../ng-autocomplete/ng-autocomplete.component";
import { NgFileuploadComponent } from "../ng-fileupload/ng-fileupload.component";
import { SignaturePadComponent } from "../signature-pad/signature-pad.component";
import {
  MatDatepickerModule,
  MatDateRangePicker,
} from "@angular/material/datepicker";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { AuthTenantService } from "../../../authentication/auth-tenant.service";
@Component({
  selector: "app-applications-stepper",
  standalone: true,
  imports: [
    MatDatepickerModule,
    // SignaturePadComponent,
    CommonModule,
    FileUploadModule,
    MatCardModule,
    MatMenuModule,
    MatTooltipModule,
    MatStepperModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    NgFileuploadComponent,
    FormsModule,
    ReactiveFormsModule,
    NgAutocompleteComponent,
    DatePickerComponent,
    MatRadioModule,
    MatIconModule,
    NgxDocViewerModule,
    MatSelectModule,
    NgxMaskDirective,
    MatSpinner,
  ],
  templateUrl: "./applications-stepper.component.html",
  styleUrls: ["./applications-stepper.component.scss"],
  providers: [DatePipe],
})
export class ApplicationsStepperComponent
  implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private formBuilder: FormBuilder,
    public formService: FormService,
    public applicationService: ApplicationService,
    public themeService: CustomizerSettingsService,
    private passwordValidatorService: PasswordValidatorService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private toastService: ToastrService,
    private sweetAlert: SweetAlertService,
    private cd: ChangeDetectorRef,
    private datePipe: DatePipe,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private location: Location,
    private deviceService: DeviceDetectorService, private tenantService: AuthTenantService,

  ) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }
  //views
  @ViewChild("signature")
  applicationSignaturePad!: SignaturePadComponent;

  @ViewChild("stepper") stepper!: MatStepper;

  @ViewChild("stepperContainer") stepperContainer!: ElementRef<HTMLDivElement>;
  // Subscriptions
  private programSubscription: Subscription | undefined;
  private scheduleSubscription: Subscription | undefined;
  isSubmitting = false;
  tenant$ = this.tenantService.tenant$
  // Data arrays
  programs: any[] = [];
  allSchedules: any[] = []; // All schedules from API
  filteredSchedules: any[] = []; // Schedules filtered by selected program
  filteredProgramDates!: any;
  displayHint: boolean = false; // Dates from the API call
  filteredScheduleTypes: any[] = []; // Unique schedule types for the selected program
  @Input() courses: object[] = [];
  @Input() countries: any;
  @Input() schedules: any[] = [];
  @Input() startDates: any = [];
  @Input() relationships: any = [];
  @Input() educationLevels: any = [];
  @Input() disabilities: string[] = [
    "Visual impairment",
    "Hearing impairment",
    "Physical disability",
    "Intellectual disability",
    "Learning disability",
    "Autism spectrum disorder",
    "Speech and language disorder",
    "Mental health condition",
    "Chronic illness",
    "Developmental disability",
    "Attention deficit hyperactivity disorder (ADHD)",
    "Cerebral palsy",
    "Down syndrome",
    "Epilepsy",
    "Multiple sclerosis",
    "Muscular dystrophy",
    "Spinal cord injury",
    "Traumatic brain injury",
    "Albinism",
    "Dwarfism",
  ];
  @Input() accommodations: string[] = [
    "Screen readers",
    "Braille displays",
    "Wheelchair ramps",
    "Accessible bathrooms",
    "Ergonomic workstations",
    "Automatic doors",
    "Height-adjustable desks",
    "Mobility aids (wheelchairs, walkers)",
    "Accessible workstations",
    "Standing desks",
  ];
  @Input() sources: string[] = [
    "Billboards",
    "Career Fair",
    "Facebook",
    "Google Ads",
    "Google Maps",
    "Google Search",
    "Instagram",
    "Laundry Mat",
    "LinkedIn",
    "Our Institution's website",
    "Newspaper",
    "Other (Please Explain)",
    "Referral (Please explain)",
    "Tik Tok",
    "Walk-In",
    "X- (Formally Twitter)",
    "Yahoo",
  ];
  @Input() ethnicities: any = [
    "American Indian/Native American",
    "Asian",
    "Arab",
    "Black/African American",
    "White not of Hispanic origin",
    "Hawaiian/Pacific Islander",
    "Hispanic/Latino",
    "Other",
  ];
  formGroups: FormGroup[] = [];

  // Loading states
  isLoadingPrograms: boolean = false;
  isLoadingSchedules: boolean = false;
  hasError: boolean = false;
  selectedDate!: Date;
  selectedOption: string | null = null;
  toggleState: boolean = false;
  toggleDisability: boolean = false;
  toggoleProgramSelection: boolean = false;

  isToggled: boolean = false;
  toggleTranscript: boolean = true;
  toggleCollegeGraduant: boolean = false;
  toggleVarsityIfCollege: boolean = false;
  toggleVarsityGraduant: boolean = false;
  toggleBackgroundInfoQone: boolean = false;
  toggleBackgroundInfoQtwo: boolean = false;
  toggleBackgroundInfoQthree: boolean = false;
  toggleBackgroundInfoQfour: boolean = false;
  toggoleMilitary: boolean = false;
  toggleEmploymentStatus: boolean = false;
  toggleCitizenship: boolean = false;
  toggleCertification: boolean = false;
  toggleCertificationQone: boolean = false;
  toggleCertificationQtwo: boolean = false;
  toggleCertificationQthree: boolean = false;
  toggleCertificationQfour: boolean = false;
  toggleCertificationQfive: boolean = false;
  toggleCertificationQsix: boolean = false;
  toggleCertificationQseven: boolean = false;
  studentApplicationId: any;
  applicationData: any;
  applicationId!: any;
  StudentApplicationData: any;
  ProgramInfoData: any;
  elementary: boolean = false;
  isDocRequired: boolean = false;
  isCNACHH: boolean = false;
  permanentResident: any;
  qualifiedImmigrant: boolean = false;
  applicationState: any;
  files: any = [];
  imageUrls: { [key: string]: string } = {};
  documentUrls: { [key: string]: string } = {};
  ssnBlobUrl: string = "";
  IdBlobUrl: string = "";
  cnaLiscenceUrl: string = "";
  collegeTranscriptBlobUrl: string = "";
  highSchoolTranscriptBlobUrl: string = "";
  transcriptUploadUrl: string = "";
  physicalExamUploadUrl: string = ""
  healthScreenUploadUrl: string = ""
  blsUploadUrl: string = ""
  backgroundCheckUploadUrl: string = ""
  drugScreenUploadUrl: string = ""
  uniqueStr = new Date().toISOString();
  hasCheckedForms: any;
  invalidIndex!: number;
  filterdScheduleTypes: any[] = [];
  isCheckedConsent: boolean = false;
  isCheckedEmployment: boolean = false;
  togglePracticalNursingTranscript: boolean = false;
  toggleRequiredPreNursingCourses: boolean = false;
  togglePreNursingChekBox: boolean = false;
  toggleRefresherCheckBox: boolean = false;
  humanAnatomyAndPhysiology1Course = false;
  humanAnatomyAndPhysiology1FileUpload = false;
  humanAnatomyAndPhysiology2Course = false;
  humanAnatomyAndPhysiology2FileUpload = false;
  medicalTerminologyCourse = false;
  medicalTerminologyFileUpload = false;
  pharmacologyOfNursingCourse = false;
  pharmacologyOfNursingFileUpload = false;
  notResident: boolean = false;
  years: (string | number)[] = [];
  permanentAddressChecked: boolean = false;
  statementChecked: boolean = false;
  filteredFutreDates: any;
  allScheduleTypes: any;
  scheduleTypeId: any;
  hasSubmitted: boolean = false;
  signatureFiles!: any[];
  preNursingTranscriptUrl: any[] = [];
  preNursingDocName: any;
  fromSidebar: boolean = false;
  isLoadingApplication: boolean = false;
  isLoadingProgramInfo: boolean = false;
  isLinear: boolean = false;
  isOther: boolean = false;
  isSubmittingApplication: boolean = false;
  isSubmittingPersonalInfo: boolean = false;
  isSubmittingEmergencyContact: boolean = false;
  isSubmittingEthnicity: boolean = false;
  isSubmittingDisability: boolean = false;
  isSubmittingPracticalNursing: boolean = false;
  isSubmittingVerification: boolean = false;
  isSubmittingStudentSource: boolean = false;
  isSubmittingMilitary: boolean = false;
  isSubmittingEducation: boolean = false;
  isSubmittingEmployment: boolean = false;
  isSubmittingCitizenship: boolean = false;
  isSubmittingBackground: boolean = false;
  isSubmittingCertificateAgreement: boolean = false;
  isSubmittingUnderstanding: boolean = false;
  isSubmittingDocuments: boolean = false;
  isSubmittingSignature: boolean = false;
  noDocRequired: boolean = false;

  // life cycles
  ngOnInit(): void {
    console.log("check state setting step", this.isLinear);
    this.setupFormListeners();
    this.initializeSubscriptions();
    this.loadInitialData();
    this.generateYears();
    this.getCountries();
    this.getDeviceDetails();
    // this.loadStudentApplicationData();
    this.route.paramMap.subscribe((params) => {
      const studentId = params.get("studentApplicationId");
      const newApplication = params.get("newApplication");

      const data = params.get("data");
      const state = history.state;
      this.studentApplicationId = state.studentApplicationId;
      this.applicationData = state.data;
      this.applicationState = state.newApplication;
      const id = sessionStorage.getItem("requestedId");
      this.fromSidebar = state.fromSideBar;

      if (
        (this.studentApplicationId && this.applicationState === false) ||
        id
      ) {
        this.getStudentApplicationForms();
        this.getProgramInfo();
      }
    });
    setTimeout(() => {
      if (this.applicationState === false && !this.fromSidebar) {
        this.getStudentApplicationForms();
        this.getProgramInfo();
      } else {
        this.clearPatchedValues();
        this.isLinear = true;
      }
    }, 500);
  }

  ngAfterViewInit(): void {
    // if (this.applicationState === false && !this.fromSidebar) {
    //   this.getStudentApplicationForms(() => {
    //     setTimeout(() => {
    //       this.setInvalidFormStep();
    //     });
    //   });
    // } else {
    //   this.clearPatchedValues();
    // }
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    this.programSubscription?.unsubscribe();
    this.scheduleSubscription?.unsubscribe();
    this.invalidIndex = 0;
    Object.values(this.imageUrls).forEach((url) => URL.revokeObjectURL(url));

    Object.values(this.documentUrls).forEach((url) => URL.revokeObjectURL(url));
  }

  // Public helper functions
  loadInitialData(): void {
    forkJoin({
      programs: this.applicationService.getPrograms(),
      schedules: this.applicationService.getSheduleTypes(),
      startDates: this.applicationService.getStartDates(),
      relationships: this.applicationService.getRelationships(),
      educationLevels: this.applicationService.getEducationLevels(),
    }).subscribe({
      next: (res) => {
        this.programs = res.programs.content.map((p: any) => ({
          id: p.id,
          programName: p.programName,
          programInitial: p.programInitial,
        }));
        this.allScheduleTypes = res.schedules.content;
        this.startDates = res.startDates.content;
        this.relationships = res.relationships.content.map((r: any) => r.name);
        this.educationLevels = res.educationLevels.content.map(
          (e: any) => e.name
        );
      },
      error: () => {
        this.toastService.error("Failed to load initial data.");
      },
    });
  }
  getCountries() {
    this.applicationService.getAllCountries().subscribe({
      next: (res) => {
        this.countries = [
          "United States",
          ...res.data
            .map((c: any) => c.country)
            .filter((c: string) => c !== "United States"),
        ];
      },
      error: (err) => {
        this.toastService.error("Couldn't fetch countries");
        console.log(err);
      },
    });
  }
  onOptionSelected(selectedProgram: any): void {
    if (selectedProgram && selectedProgram.id) {
      const selectedProgramId = selectedProgram.id;
    }
  }

  handleZipCode(e: any, item: any) {
    const inputElement = e.target as HTMLInputElement;
    const zipcode = inputElement.value;
    this.GetStateFromZipCode(zipcode, item);
  }

  onStepChange(event: StepperSelectionEvent): void {
    if (event.selectedIndex < 9) {
      this.scrollToPosition();
    } else {
      this.scrollToPosition("bottom");
    }
    const form = event.selectedStep.stepControl as FormGroup;

    console.log("Active step index:", event.selectedIndex);
    console.log("Form for this step:", form);
  }

  onSubmit(form: any) {
    // console.log("form", form.value);
    if (this.StudentApplicationData?.applicationStatus === "APPROVED") {
      form.markAsPristine();
      form.markAsUntouched();
      if (form === this.formService.signatureForm) {
        this.sweetAlert.success("Application Already Approved");
      }
      this.stepper.next();
      return;
    }
    form.markAllAsTouched();
    this.logInvalidControls(form);
    this.isSubmitting = true;
    console.log("form submitting", this.isSubmitting);

    try {
      this.postApplication(form);
      this.putPersonalInfo(form);
      this.putEmergencyContact(form);
      this.putEthnicity(form);
      this.putDisability(form);
      this.putProgramOptions(form);
      this.putStudentVerification(form);
      this.putStudentSource(form);
      this.putMilitaryRecord(form);
      this.putEducationBackground(form);
      this.putEmploymentAndExperience(form);
      this.putCitizenShip(form);
      this.putBackgroundInfo(form);
      this.putCertificateAgreement(form);
      this.putStatementOfUnderstanding(form);
      this.putDocumentUploads(form);
      this.putApplicantSignature(form);

      // Optionally show success message here
    } catch (error) {
      console.error("Form submission failed", error);
      // Optionally show error message here
    } finally {
      this.isSubmitting = false;
      console.log("form finished submitting", this.isSubmitting);
    }
  }

  onSaveContinueLater(form?: any) {
    if (this.StudentApplicationData?.applicationStatus === "APPROVED") {
      form.markAsPristine();
      form.markAsUntouched();
      this.sweetAlert.success("Application Already Approved");
      // form.mark();

      setTimeout(() => {
        this.router.navigate(["/student-dashboard/welcome"]);
      }, 2000);
      return;
    }
    if (form) {
      this.onSubmit(form);
    }

    setTimeout(() => {
      this.router.navigate(["/student-dashboard/welcome"]);
    }, 2000);
  }

  onZipInput(event: Event, item: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, "");
    if (item === "zipcode") {
      this.formService.personalInfoForm
        .get("zipCode")
        ?.setValue(inputElement.value);
    } else if (item === "pzipcode") {
      this.formService.personalInfoForm
        .get("permanentZipCode")
        ?.setValue(inputElement.value);
    }
  }

  onDateSelected(date: Date): void {
    this.selectedDate = date;
  }

  onCourseSelectionChange(): void {
    const form = this.formService.practicalNursingForm;

    this.humanAnatomyAndPhysiology1FileUpload =
      form.get("humanAnatomyAndPhysiology1")?.value === "Yes";
    this.humanAnatomyAndPhysiology1Course =
      form.get("humanAnatomyAndPhysiology1")?.value === "No";

    this.humanAnatomyAndPhysiology2FileUpload =
      form.get("humanAnatomyAndPhysiology2")?.value === "Yes";
    this.humanAnatomyAndPhysiology2Course =
      form.get("humanAnatomyAndPhysiology2")?.value === "No";

    this.medicalTerminologyFileUpload =
      form.get("medicalTerminology")?.value === "Yes";
    this.medicalTerminologyCourse =
      form.get("medicalTerminology")?.value === "No";

    this.pharmacologyOfNursingFileUpload =
      form.get("pharmacologyOfNursing")?.value === "Yes";
    this.pharmacologyOfNursingCourse =
      form.get("pharmacologyOfNursing")?.value === "No";
  }

  onPreNursingCheck(checked: boolean) {
    if (checked) {
      this.toggleRequiredPreNursingCourses =
        !this.toggleRequiredPreNursingCourses;
    }
  }

  onRefresherCheck(checked: boolean): void {
    const refresherCourse =
      this.formService.practicalNursingForm.get("refresherCourse");

    if (checked) {
      this.toggleRefresherCheckBox = !this.toggleRefresherCheckBox;
      refresherCourse?.setValidators(Validators.required);
    } else {
      refresherCourse?.clearValidators();
      this.toggleRefresherCheckBox = !this.toggleRefresherCheckBox;
    }
    refresherCourse?.updateValueAndValidity();
  }

  handleFiles(
    event: { id: string; files: File[] },
    form: FormGroup,
    control: string
  ): void {
    const formControl = form.get(control);
    if (formControl) {
      formControl.setValue(event.files);
    } else {
      console.error(`FormControl '${control}' not found in the provided form.`);
    }

    if (form === this.formService.documentUploadForm) {
      this.files.push({ file: event.files[0], id: event.id });
      const fileToUpload = event.files[0];
      const fileExtension = fileToUpload.name.split(".").pop()?.toLowerCase();
      const fieldName = event.id;
      if (
        (fieldName === "highSchoolTranscript" ||
          fieldName === "collegeTranscript" ||
          fieldName === "cna" ||
          fieldName === "ssn" ||
          fieldName === "Id") &&
        (fileExtension === "jpeg" ||
          fileExtension === "jpg" ||
          fileExtension === "png")
      ) {
        // Create a URL for the uploaded image
        if (this.imageUrls[fieldName] || this.documentUrls[fieldName]) {
          URL.revokeObjectURL(this.imageUrls[fieldName]);
          URL.revokeObjectURL(this.documentUrls[fieldName]);
        }
        this.imageUrls[fieldName] = URL.createObjectURL(fileToUpload);

        // Check if the uploaded file is a PDF
      } else if (
        ((fieldName === "highSchoolTranscript" ||
          fieldName === "collegeTranscript" ||
          fieldName === "ssn" ||
          fieldName === "cna" ||
          fieldName === "Id") &&
          fileExtension === "pdf") ||
        fileExtension === "doc" ||
        fileExtension === "docx"
      ) {
        // Create a URL for the uploaded document
        if (this.documentUrls[fieldName] || this.imageUrls[fieldName]) {
          URL.revokeObjectURL(this.documentUrls[fieldName]);
          URL.revokeObjectURL(this.imageUrls[fieldName]);
        }
        this.documentUrls[fieldName] = URL.createObjectURL(fileToUpload);
      }
    }
  }

  handleTranscripts(
    event: { id: string; files: File[] },
    form: FormGroup,
    control: string
  ): void {
    const formControl = form.get(control);
    if (formControl) {
      formControl.setValue(event.files);
    } else {
      console.error(`FormControl '${control}' not found in the provided form.`);
    }
  }

  onToggle(isChecked: boolean) {
    this.toggleState = isChecked;

    if (this.toggleState) {
    } else {
    }
  }

  onCheckConsent(isChecked: boolean) {
    this.isCheckedConsent = isChecked;
  }

  onPermanentAddressChecked(isChecked: boolean) {
    this.permanentAddressChecked = isChecked;
  }

  onStatementOfUnderstandingChecked(isChecked: boolean) {
    this.statementChecked = isChecked;
    this.formService.statementOfUnderstandingForm
      .get("isTermsAndConditions")
      ?.setValue(isChecked);
  }

  onCheckCurrentEmploymentStatus(isChecked: boolean) {
    this.isCheckedEmployment = isChecked;
  }

  onToggleDisability(value: any) {
    this.toggleDisability = value === "Yes";

    if (this.toggleDisability) {
      this.updateFormControlValidators(
        this.formService.disabilityForm,
        ["disability", "typeOfAccommodation"],
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.disabilityForm,
        ["disability", "typeOfAccommodation"],
        "clear"
      );
    }
  }

  onToggleMilitary(value: any): void {
    this.toggoleMilitary = value === "Yes";

    if (this.toggoleMilitary) {
      this.updateFormControlValidators(
        this.formService.usMilitaryRecordForm,
        ["militaryBranch", "startDate", "dischargeStatus"],
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.usMilitaryRecordForm,
        ["militaryBranch", "startDate", "dischargeStatus"],
        "clear"
      );
    }
  }
  onSelectSource(selected: any) {
    this.isOther = [
      "Other (Please Explain)",
      "Referral (Please explain)",
    ].includes(selected);
    if (this.isOther) {
      this.updateFormControlValidators(
        this.formService.studentSourceForm,
        ["studentSourceText"],
        "set"
      );
    } else {
      this.updateFormControlValidators(
        this.formService.studentSourceForm,
        ["studentSourceText"],
        "clear"
      );
    }
  }
  onSelectProgram(selected: any) {
    const excludedPrograms = [
      "Certified Nurse Aide & Certified Home Health Aide  Combo [CNA/CHHA]",
      "Certified Nurse Aide [CNA]",
      "Advanced Cardiovascular Life Support Initial [ACLS]",
      "Advanced Cardiovascular Life Support: Renewal [ACLS]",
      "Basic Life Support for Healthcare Providers: Initial and Renewal [BLS]",
      "Pediatric Advanced Life Support (PALS)",
      "Certified Home Health Aide (CHHA) Deeming",
    ];

    const docControls = ["highSchoolTranscript", "collegeTranscript"];

    this.isCNACHH = excludedPrograms.includes(selected.programName);
    const shouldRequireTranscripts = !this.isCNACHH && !this.isDocRequired;

    // Higher education means elementary = true

    if (shouldRequireTranscripts) {
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        docControls,
        "clear"
      );
    } else {
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        docControls,
        "set",
        Validators.required
      );
    }

    this.cdRef.detectChanges();
  }

  onSelectElementary(selected: any) {
    const elementarySelection = [
      "No Formal Education",
      "Some Elementary School",
      "Elementary School",
      "Some Middle School",
      "Middle School",
      "Some High School",
    ];

    const controls = [
      "highSchoolName",
      "graduatedCollege",
      "highSchoolGraduationYear",
    ];
    const docControls = ["highSchoolTranscript", "collegeTranscript"];

    const isElementary = elementarySelection.includes(selected); // simpler logic

    this.elementary = !isElementary; // Higher education means elementary = true
    this.isDocRequired = isElementary; // Higher education means elementary = true

    if (this.elementary) {
      // High School or above
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "set",
        Validators.required
      );
      this.formService.educationalBackgroundForm
        .get("highSchoolGraduationYear")
        ?.setValidators([Validators.min(1000), Validators.max(9999)]);

      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        ["canReadWriteEnglish"],
        "clear"
      );
    } else {
      // Elementary level
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "clear"
      );

      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        ["canReadWriteEnglish"],
        "set",
        Validators.required
      );
    }
    const showTranscriptUploads = !this.isCNACHH && !this.isDocRequired;

    this.updateFormControlValidators(
      this.formService.documentUploadForm,
      docControls,
      showTranscriptUploads ? "set" : "clear",
      Validators.required
    );
  }

  onToggleCollegeGraduant(value: any) {
    this.toggleCollegeGraduant = value === "Yes";

    const controls = [
      "collegeGraduationMonthYear",
      "graduatedUniversity",
      "collegeName",
      "major",
      "gpa",
    ];

    if (this.toggleCollegeGraduant) {
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "clear"
      );
    }
  }

  onToggleVarsityGraduant(value: any) {
    this.toggleVarsityGraduant = value === "Yes";

    const controls = ["graduatedUniversity"];

    if (this.toggleVarsityGraduant) {
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "clear"
      );
    }
  }

  onToggleVarsityIfCollege(value: any) {
    this.toggleVarsityIfCollege = value === "Yes";

    const controls = ["universityGraduationMonthYear"];

    if (this.toggleVarsityIfCollege) {
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.educationalBackgroundForm,
        controls,
        "clear"
      );
    }
  }

  onToggleEmploymentStatus(value: any) {
    this.toggleEmploymentStatus = value === "Yes";

    const controls = ["employerName", "startDate", "position", "hourlypay"];

    if (this.toggleEmploymentStatus) {
      this.updateFormControlValidators(
        this.formService.employmentForm,
        controls,
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.employmentForm,
        controls,
        "clear"
      );
    }
  }

  onToggleCitizenship(value: any) {
    this.toggleCitizenship = value === "No";

    const controls = ["countryOfCitizenship", "permanentResidentStatus"];

    if (this.toggleCitizenship) {
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        controls,
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        controls,
        "clear"
      );
    }
  }

  onTogglePermanentResident(value: any) {
    this.permanentResident = value === "Yes";
    this.notResident = value === "No";
    const residentControls = ["alienNumber"];
    const nonResidentControls = ["qualifiedImmigrant"];

    // Resident applicant
    if (this.permanentResident) {
      // Set validators for Resident and clear Non-Resident fields/validators
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        residentControls,
        "set",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        nonResidentControls,
        "clear" // Clear the value of non-resident control
      );
    }

    // Non-Resident applicant
    if (this.notResident) {
      // Set validators for Non-Resident and clear Resident fields/validators
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        nonResidentControls,
        "set",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        residentControls,
        "clear" // Clear the value of resident control
      );
    }

    // If neither is selected, clear both sets of controls and values
    if (!this.permanentResident && !this.notResident) {
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        residentControls,
        "clear"
      );
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        nonResidentControls,
        "clear"
      );
    }
  }

  onToggleCertification(question: any, value: any) {
    const form = this.formService.certificationForm;

    switch (question) {
      case "Q1":
        this.toggleCertificationQone = value === "No";
        this.toggleCertFieldValidation("reasonOne", value === "No");
        break;
      case "Q2":
        this.toggleCertificationQtwo = value === "No";
        this.toggleCertFieldValidation("reasonTwo", value === "No");
        break;
      case "Q3":
        this.toggleCertificationQthree = value === "No";
        this.toggleCertFieldValidation("reasonThree", value === "No");
        break;
      case "Q4":
        this.toggleCertificationQfour = value === "No";
        this.toggleCertFieldValidation("reasonFour", value === "No");
        break;
      case "Q5":
        this.toggleCertificationQfive = value === "No";
        this.toggleCertFieldValidation("reasonFive", value === "No");
        break;
      case "Q6":
        this.toggleCertificationQsix = value === "No";
        this.toggleCertFieldValidation("reasonSix", value === "No");
        break;
    }
  }

  onToggleQualifiedImmigrant(value: any) {
    this.qualifiedImmigrant = value === "Yes";
    const controls = ["hasVisa", "I94"];
    if (this.qualifiedImmigrant) {
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        controls,
        "set",
        Validators.required
      );
    } else {
      this.updateFormControlValidators(
        this.formService.citizenshipForm,
        controls,
        "clear"
      );
    }
  }

  onToggleBackgroundInfo(question: any, value: any) {
    const form = this.formService.backgroundInfoForm;

    switch (question) {
      case "Q1":
        this.toggleBackgroundInfoQone = value === "Yes";
        this.toggleFieldValidation("reasonOne", value === "Yes");
        break;
      case "Q2":
        this.toggleBackgroundInfoQtwo = value === "Yes";
        this.toggleFieldValidation("reasonTwo", value === "Yes");
        break;
      case "Q3":
        this.toggleBackgroundInfoQthree = value === "Yes";
        this.toggleFieldValidation("reasonThree", value === "Yes");
        break;
      case "Q4":
        this.toggleBackgroundInfoQfour = value === "Yes";
        this.toggleFieldValidation("reasonFour", value === "Yes");
        break;
    }
  }

  handleSignatureSaved(blob: Blob): void {
    // Optional: Log the blob for verification
    if (blob) {
      this.formService.signatureForm.get("signature")?.setValue(blob);
      this.formService.signatureForm.get("signature")?.clearValidators();
      this.formService.signatureForm.get("signature")?.updateValueAndValidity();
    }
  }
  getDeviceDetails(): void {
    const deviceInfo = this.deviceService.getDeviceInfo();
    console.log(deviceInfo);
  }
  //API Calls
  private fetchProgramDates(programId: number, scheduleTypeId: number): void {
    this.applicationService
      .fetchProgramDates(programId, scheduleTypeId)
      .subscribe({
        next: (dates) => {
          this.filteredProgramDates = dates;
          this.displayHint = true;
        },
        // error handling...
      });
  }
  private getProgramInfo(responseId?: any) {
    console.log("<<Start of program info fetch>>>");

    if (responseId) {
      this.isLoadingProgramInfo = true;
      console.log("<<Fetching of program info with responseId>>>");
      this.applicationService.getprogramInfo(responseId).subscribe({
        next: (response) => {
          this.ProgramInfoData = response;
          this.isLoadingProgramInfo = false;
          console.log("<<Begining patch>>");

          this.patchStepForms(this.formService.programInfoForm, response);
        },
        error: (err) => {
          this.toastService.error("Unknown error occurred");
          this.isLoadingProgramInfo = false;
        },
      });

      return;
    }
    const id = sessionStorage.getItem("requestedId");
    if (this.studentApplicationId) {
      this.isLoadingProgramInfo = true;
      console.log("<<Fetching of program info with applicationId>>>");
      this.applicationService
        .getprogramInfo(this.studentApplicationId)
        .subscribe({
          next: (response) => {
            this.ProgramInfoData = response;
            this.isLoadingProgramInfo = false;
            console.log("<<Begining patch>>");
            this.patchStepForms(this.formService.programInfoForm, response);
          },
          error: (err) => {
            this.toastService.error("Unknown error occurred");
            this.isLoadingProgramInfo = false;
          },
        });
    } else if (id && !this.studentApplicationId) {
      this.isLoadingProgramInfo = true;
      this.applicationService.getprogramInfo(id).subscribe({
        next: (response) => {
          this.ProgramInfoData = response;
          this.isLoadingProgramInfo = false;
        },
        error: (err) => {
          this.toastService.error("Unknown error occurred");
          this.isLoadingProgramInfo = false;
        },
      });
    }
  }
  private checkIfDocumentsRequired(data: any): boolean {
    const fieldsToCheck = [
      "reqHighSchoolDipGed",
      "reqCollegeTrans",
      "reqGovPhotoId",
      "reqSSNDoc",
      "reqCNALicense",
      "reqPhysicalExam",
      "reqHealthScreen",
      "reqBLS",
      "reqBackgroundCheck",
      "reqDrugScreen"
    ];

    return fieldsToCheck.every(
      key => data[key] === false || data[key] === null
    );
  }
  private handleApplicationDetails(response: any) {
    this.StudentApplicationData = response;

    this.StudentApplicationData.noDocumentsRequired =
      this.checkIfDocumentsRequired(response);

    console.log(
      "Docs requirement",
      this.StudentApplicationData.noDocumentsRequired
    );

    this.patchFormControls();
  }

  private fetchApplicationDetails(applicationId: string) {
    this.applicationService.getApplicationDetails(applicationId).subscribe({
      next: (response) => {
        this.handleApplicationDetails(response);
        this.isLoadingApplication = false;
        this.isSubmittingApplication = false;
      },
      error: () => {
        this.isLoadingApplication = false;
        this.isSubmittingApplication = false;
      },
    });
  }

  private getStudentApplicationForms() {
    const id = sessionStorage.getItem("requestedId");
    this.isLoadingApplication = true;

    if (this.studentApplicationId) {
      this.fetchApplicationDetails(this.studentApplicationId);
    }
    else if (id) {
      this.fetchApplicationDetails(id);
    }
  }
  // private getStudentApplicationForms() {
  //   const id = sessionStorage.getItem("requestedId");
  //   this.isLoadingApplication = true;

  //   if (this.studentApplicationId) {
  //     // this.StudentApplicationData = this.applicationData;
  //     this.applicationService
  //       .getApplicationDetails(this.studentApplicationId)
  //       .subscribe({
  //         next: (response) => {
  //           this.StudentApplicationData = response;

  //           this.patchFormControls();
  //           const fieldsToCheck = [
  //             "reqHighSchoolDipGed",
  //             "reqCollegeTrans",
  //             "reqGovPhotoId",
  //             "reqSSNDoc",
  //             "reqCNALicense",
  //             "reqPNATranscript",
  //             "reqPhysicalExam",
  //             "reqHealthScreen",
  //             "reqBLS",
  //             "reqBackgroundCheck",
  //             "reqDrugScreen"
  //           ];

  //           this.StudentApplicationData.noDocumentsRequired = fieldsToCheck.every(
  //             key => this.StudentApplicationData[key] === false || this.StudentApplicationData[key] === null
  //           );
  //           console.log("Docs requirement", this.StudentApplicationData.noDocumentsRequired)
  //           this.isLoadingApplication = false;
  //         },
  //         error: (err) => {
  //           this.isLoadingApplication = false;
  //         },
  //       });
  //   } else if (id && !this.studentApplicationId) {
  //     this.applicationService.getApplicationDetails(id).subscribe({
  //       next: (response) => {
  //         this.StudentApplicationData = response;
  //         const fieldsToCheck = [
  //           "reqHighSchoolDipGed",
  //           "reqCollegeTrans",
  //           "reqGovPhotoId",
  //           "reqSSNDoc",
  //           "reqCNALicense",
  //           "reqPNATranscript",
  //           "reqPhysicalExam",
  //           "reqHealthScreen",
  //           "reqBLS",
  //           "reqBackgroundCheck",
  //           "reqDrugScreen"
  //         ];

  //         this.StudentApplicationData.noDocumentsRequired = fieldsToCheck.every(
  //           key => this.StudentApplicationData[key] === false || this.StudentApplicationData[key] === null
  //         );
  //         console.log("Docs requirement", this.StudentApplicationData.noDocumentsRequired)
  //         this.isLoadingApplication = false;
  //         this.patchFormControls();
  //       },
  //       error: (err) => {
  //         this.isLoadingApplication = false;
  //       },
  //     });
  //   } else {
  //   }
  // }

  private getUrlDocument(
    url: string,
    targetProperty:
      | "highSchoolTranscript"
      | "collegeTranscript"
      | "ssn"
      | "Id"
      | "cna"
      | "transcript"
      | "drugScreen"
      | "backgroundCheck"
      | "bls"
      | "healthScreen"
      | "physicalExam"
  ) {
    if (url) {
      const convertedUrl = this.convertToHttps(url);
      this.applicationService.getUrlDocuments(convertedUrl).subscribe({
        next: (response) => {
          const blobUrl = URL.createObjectURL(response);
          const extension = this.getFileExtension(response.type);
          const fileName = `${targetProperty}.${extension}`;
          const file = new File([response], fileName, { type: response.type });

          switch (targetProperty) {
            case "highSchoolTranscript":
              this.highSchoolTranscriptBlobUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();

              break;

            case "collegeTranscript":
              this.collegeTranscriptBlobUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();

              break;
            case "cna":
              this.cnaLiscenceUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();

              break;

            case "transcript":
              this.transcriptUploadUrl = blobUrl;
              this.formService.practicalNursingForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.practicalNursingForm.updateValueAndValidity();

              break;

            case "ssn":
              this.ssnBlobUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();

              break;

            case "Id":
              this.IdBlobUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();
              break;

            case "bls":
              this.blsUploadUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();
              break;

            case "drugScreen":
              this.drugScreenUploadUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();
              break;

            case "backgroundCheck":
              this.backgroundCheckUploadUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();
              break;

            case "healthScreen":
              this.healthScreenUploadUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();
              break;

            case "physicalExam":
              this.physicalExamUploadUrl = blobUrl;
              this.formService.documentUploadForm
                .get(targetProperty)
                ?.setValue(file);
              this.formService.documentUploadForm.updateValueAndValidity();
              break;

          }
        },
        error: (err) => {
          console.error(`Error fetching ${targetProperty} document:`, err);
        },
      });
    }
  }

  private postApplication(form: any) {
    if (form === this.formService.programSelectionForm) {
      const formValue = this.formService.programSelectionForm.value;
      const id = sessionStorage.getItem("requestedId");
      const scheduleId = formValue.schedule;
      const selectedProgramDate = formValue.startDate;

      const payload = {
        programId: formValue.selectProgram?.id,
        scheduleTypeId: formValue.schedule?.id,
        programScheduleId: formValue.startDate?.id,
        reasonForApplication: formValue.reasonForApplication,
      };

      // Validate payload before sending
      if (
        !formValue.selectProgram?.id ||
        !formValue.schedule?.id ||
        !formValue.startDate?.id
      ) {
        this.toastService.error("Please complete all required fields");
        console.error("Invalid payload:", formValue);
        return;
      }

      // Always allow updates, not just first-time submissions
      if (!this.studentApplicationId && !id && this.applicationState === true) {
        this.isSubmittingApplication = true;

        this.applicationService.postProgramSelection(payload).subscribe({
          next: (response) => {
            this.applicationId = response.resourceId;
            sessionStorage.setItem("requestedId", this.applicationId);

            this.fetchApplicationDetails(response.resourceId);

            this.getProgramInfo(response.resourceId);
            this.toastService.success("Program selection posted successfully");

            this.stepper.next();
          },
          error: (error: any) => {
            this.isSubmittingApplication = false;
            ("An unexpected error occurred.");
            // this.toastService.error("Program selection post failed");
            const userMessage =
              error?.error?.errors?.[0]?.defaultUserMessage ||
              error?.error?.developerMessage ||
              error?.message ||
              "Student already has an application for this program and .";

            this.sweetAlert.error(userMessage);

            setTimeout(() => {
              this.router.navigateByUrl("/student-dashboard/welcome");
            }, 2000);
          },
        });
      } else if (this.studentApplicationId || id) {
        const applicationID = this.studentApplicationId ?? id;
        const putPayload = {
          studentApplicationId: applicationID,
          programId: formValue.selectProgram?.id,
          scheduleTypeId: scheduleId?.id,
          programScheduleId: selectedProgramDate?.id,
          reasonForApplication: formValue.reasonForApplication,
        };
        this.isSubmittingApplication = true;
        this.applicationService.putProgramSelection(putPayload).subscribe({
          next: (response) => {
            this.applicationId = response.resourceId;
            sessionStorage.setItem("requestedId", this.applicationId);

            this.fetchApplicationDetails(response.resourceId);

            this.getProgramInfo(response.resourceId);
            this.toastService.success("Program selection updated successfully");

            this.stepper.next();
          },
          error: (error) => {
            this.toastService.error("Program selection update failed");
          },
        });
        // this.toastService.success("this selection has been submitted ");
      }
    }
  }

  private putPersonalInfo(form: any) {
    if (form === this.formService.personalInfoForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),

        // Physical address (conditional: permanent vs. mailing)
        phyStreetAddress: this.permanentAddressChecked
          ? this.formService.personalInfoForm.value.permanentStreetAddress
          : this.formService.personalInfoForm.value.streetAddress,
        phyZipCode: this.permanentAddressChecked
          ? this.formService.personalInfoForm.value.permanentZipCode
          : this.formService.personalInfoForm.value.zipCode,
        phyCity: this.permanentAddressChecked
          ? this.formService.personalInfoForm.value.permanentCity
          : this.formService.personalInfoForm.value.city,
        phyState: this.permanentAddressChecked
          ? this.formService.personalInfoForm.value.permanentState
          : this.formService.personalInfoForm.value.state,

        // Mailing address (always from mailing fields)
        mailStreetAddress:
          this.formService.personalInfoForm.value.streetAddress,
        mailZipCode: this.formService.personalInfoForm.value.zipCode,
        mailCity: this.formService.personalInfoForm.value.city,
        mailState: this.formService.personalInfoForm.value.state,

        // Other fields
        mobileNumber: this.formService.personalInfoForm.value.phoneNumber,
        firstName: this.formService.personalInfoForm.value.firstName,
        middleName: this.formService.personalInfoForm.value.middleName,
        lastName: this.formService.personalInfoForm.value.lastName,
        ssn: this.formService.personalInfoForm.value.ssn,
        dob: this.formService.personalInfoForm.value.dateOfBirth,
        emailAddress: this.formService.personalInfoForm.value.email,
        consent: this.formService.personalInfoForm.value.messageConsent,
      };
      this.isSubmittingPersonalInfo = true;
      this.applicationService.putPersonalInfo(payload).subscribe({
        next: (response) => {
          this.isSubmittingPersonalInfo = false;
          this.toastService.success("personal information submited");
          this.stepper.next();
        },
        error: (error) => {
          this.isSubmittingPersonalInfo = false;
          this.toastService.error("personal info submission failed");
          console.error(error);
        },
      });
    }
  }

  private putEmergencyContact(form: any) {
    if (form === this.formService.emergencyContactForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        emergencyFirstName:
          this.formService.emergencyContactForm.value.emergencyFirstName,
        emergencyMiddleName:
          this.formService.emergencyContactForm.value.emergencyMiddleName,
        emergencyLastName:
          this.formService.emergencyContactForm.value.emergencyLastName,
        emergencyEmail:
          this.formService.emergencyContactForm.value.emergencyEmailAddress,
        emergencyPhone:
          this.formService.emergencyContactForm.value.emergencyPhoneNumber,
        relationship: this.formService.emergencyContactForm.value.relationship,
        fullAddress: this.formService.emergencyContactForm.value.fulladdress,
      };
      this.isSubmittingEmergencyContact = true;
      this.applicationService.putEmergencyContact(payload).subscribe({
        next: (response) => {
          this.isSubmittingEmergencyContact = false;
          this.toastService.success("emergency contact  submited");
          this.stepper.next();
        },
        error: (error) => {
          this.isSubmittingEmergencyContact = false;
          this.toastService.error("emergency contact submission ");
          console.error(error);
        },
      });
    }
  }

  private putEthnicity(form: any) {
    if (form === this.formService.ethnicityForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        ethnicRace: this.formService.ethnicityForm.value.ethnicity,
        gender: this.formService.ethnicityForm.value.gender,
      };
      this.isSubmittingEthnicity = true;
      this.applicationService.putEthnicity(payload).subscribe({
        next: (response) => {
          this.isSubmittingEthnicity = false;
          this.toastService.success("ethnicity info submited");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error("ethnicity submission failed");
          console.error(error);
          this.isSubmittingEthnicity = false;
        },
      });
    }
  }

  private putDisability(form: any) {
    if (form === this.formService.disabilityForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        hasDisability:
          this.formService.disabilityForm.value.disabilityPresence === "Yes"
            ? true
            : false,
        disabilityDescription:
          this.formService.disabilityForm.value.disability || "",
        accommodationRequest:
          this.formService.disabilityForm.value.typeOfAccommodation || "",
      };
      this.isSubmittingDisability = true;

      this.applicationService.putDisability(payload).subscribe({
        next: (response) => {
          this.isSubmittingDisability = false;

          this.toastService.success("disability submitted");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error("disability submission failed");
          console.error(error);
          this.isSubmittingDisability = false;
        },
      });
    }
  }

  private putProgramOptions(form: any) {
    if (form === this.formService.practicalNursingForm) {
      const formData = new FormData();

      // Append basic values
      formData.append(
        "studentApplicationId",
        this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId") // Ensure it's a string
      );
      formData.append(
        "humanAnatomyAndPhysiology1",
        String(
          this.formService.practicalNursingForm.get(
            "humanAnatomyAndPhysiology1"
          )?.value === "Yes"
            ? true
            : false
        )
      );
      formData.append(
        "humanAnatomyAndPhysiology1Course",
        String(
          this.formService.practicalNursingForm.get(
            "humanAnatomyAndPhysiology1Course"
          )?.value === true
            ? "Human Anatomy and Physiology I"
            : ""
        )
      );
      formData.append(
        "humanAnatomyAndPhysiology2",
        String(
          this.formService.practicalNursingForm.get(
            "humanAnatomyAndPhysiology2"
          )?.value === "Yes"
            ? true
            : false
        )
      );
      formData.append(
        "humanAnatomyAndPhysiology2Course",
        String(
          this.formService.practicalNursingForm.get(
            "humanAnatomyAndPhysiology2Course"
          )?.value === true
            ? "Human Anatomy and Physiology II"
            : ""
        )
      );
      formData.append(
        "medicalTerminology",
        String(
          this.formService.practicalNursingForm.get("medicalTerminology")
            ?.value === "Yes"
            ? true
            : false
        )
      );
      formData.append(
        "medicalTerminologyCourse",
        String(
          this.formService.practicalNursingForm.get("medicalTerminologyCourse")
            ?.value === true
            ? "Medical Terminology"
            : ""
        )
      );
      formData.append(
        "pharmacologyOfNursing",
        String(
          this.formService.practicalNursingForm.get("pharmacologyOfNursing")
            ?.value === "Yes"
            ? true
            : false
        )
      );
      formData.append(
        "pharmacologyOfNursingCourse",
        String(
          this.formService.practicalNursingForm.get(
            "pharmacologyOfNursingCourse"
          )?.value === true
            ? "Pharmacology of Nursing"
            : ""
        )
      );
      formData.append(
        "refresher",
        String(!!this.formService.practicalNursingForm.get("refresher")?.value)
      );
      formData.append(
        "refresherCourse",
        String(
          this.formService.practicalNursingForm.get("refresherCourse")?.value
        )
      );

      formData.append("transcriptUpload", "true");

      const files =
        this.formService.practicalNursingForm.get("transcript")?.value;

      if (files) {
        const fileArray = Array.isArray(files) ? files : [files];
        fileArray.forEach((file: File, index: number) => {
          if (file instanceof File) {
            const ext = file.name.split(".").pop();
            const fileName = `pnatranscript.${ext}`;
            formData.append("files", file, fileName);
            formData.append("fileNames", fileName);
          } else {
            console.error(`Invalid file at index ${index}:`, file);
          }
        });
      }
      this.isSubmittingPracticalNursing = true;

      this.applicationService.putProgramOptions(formData).subscribe({
        next: (response) => {
          this.isSubmittingPracticalNursing = false;

          this.toastService.success("Program options submitted");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error("Submission failed");
          console.error("Submission error details:", error);
          this.isSubmittingPracticalNursing = false;
        },
      });
    }
  }

  private putStudentVerification(form: any) {
    if (form === this.formService.studentVerificationForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        isFirstTimeStudentAtMedNoc:
          this.formService.studentVerificationForm.value.firstTimeProgram ===
            "Yes"
            ? true
            : false,
        isRetakingProgramFromAnotherSchool:
          this.formService.studentVerificationForm.value.retakingProgram ===
            "Yes"
            ? true
            : false,
        hasTakenOtherProgramsAtMedNoc:
          this.formService.studentVerificationForm.value.pastProgram === "Yes"
            ? true
            : false,
      };
      this.isSubmittingVerification = true;
      this.applicationService.putStudentVerification(payload).subscribe({
        next: (response) => {
          this.isSubmittingVerification = false;
          this.toastService.success(
            "student verification information submited"
          );
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error("student verification failed");
          console.error(error);
          this.isSubmittingVerification = false;
        },
      });
    }
  }

  private putStudentSource(form: any) {
    if (form === this.formService.studentSourceForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        sourceOfReferral: this.formService.studentSourceForm.value.source,
        studentSourceText:
          this.formService.studentSourceForm.value.studentSourceText,
      };

      this.isSubmittingStudentSource = true;
      this.applicationService.putStudentSource(payload).subscribe({
        next: (response) => {
          this.isSubmittingStudentSource = false;
          this.toastService.success("student sourcesubmited");
          this.stepper.next();
        },
        error: (error) => {
          this.isSubmittingStudentSource = false;
          this.toastService.error(" submission failed");
          console.error(error);
        },
      });
    }
  }

  private putMilitaryRecord(form: any) {
    if (form === this.formService.usMilitaryRecordForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        isMilitaryOrVeteran:
          this.formService.usMilitaryRecordForm.value
            .currentMilitaryOrVeteran === "Yes"
            ? true
            : false,
        militaryBranch:
          this.formService.usMilitaryRecordForm.value.militaryBranch,
        militaryEntryDate:
          this.formService.usMilitaryRecordForm.value.startDate,
        militaryDischargeDate:
          this.formService.usMilitaryRecordForm.value.endDate,
        militaryAchievement:
          this.formService.usMilitaryRecordForm.value.dischargeStatus,
      };
      this.isSubmittingMilitary = true;
      this.applicationService.putMilitaryRecord(payload).subscribe({
        next: (response) => {
          this.isSubmittingMilitary = false;
          this.toastService.success("military record submitted");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error(" submission failed");
          console.error(error);
          this.isSubmittingMilitary = false;
        },
      });
    }
  }

  private putEducationBackground(form: any) {
    if (form === this.formService.educationalBackgroundForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        highestEducationLevel:
          this.formService.educationalBackgroundForm.value.highestEducation,
        canReadWriteEnglish: !this.elementary
          ? this.formService.educationalBackgroundForm.value
            .canReadWriteEnglish === "Yes"
            ? true
            : false
          : null,
        highSchoolName:
          this.formService.educationalBackgroundForm.value.highSchoolName,
        highSchoolGraduationYear:
          this.formService.educationalBackgroundForm.value
            .highSchoolGraduationYear,
        collegeName:
          this.formService.educationalBackgroundForm.value.collegeName,
        collegeMajor: this.formService.educationalBackgroundForm.value.major,
        collegeGPA: this.formService.educationalBackgroundForm.value.gpa,
        collegeGraduationDate:
          this.formService.educationalBackgroundForm.value
            .collegeGraduationMonthYear,
        didGraduateCollege:
          this.formService.educationalBackgroundForm.value.graduatedCollege ===
            "Yes"
            ? true
            : false,
        universityName:
          this.formService.educationalBackgroundForm.value.universityName,
        universityMajor:
          this.formService.educationalBackgroundForm.value.universityMajor,
        universityGPA:
          this.formService.educationalBackgroundForm.value.universityGpa,
        universityGraduationDate:
          this.formService.educationalBackgroundForm.value
            .universityGraduationMonthYear,
        didGraduateUniversity:
          this.formService.educationalBackgroundForm.value
            .graduatedUniversity === "Yes"
            ? true
            : false,
      };
      this.isSubmittingEducation = true;
      this.applicationService.putEducationBackround(payload).subscribe({
        next: (response) => {
          this.isSubmittingEducation = false;
          this.toastService.success("education info submited");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error(" submission failed");
          console.error(error);
          this.isSubmittingEducation = false;
        },
      });
    }
  }

  private putEmploymentAndExperience(form: any) {
    if (form === this.formService.employmentForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        isCurrentlyEmployed:
          this.formService.employmentForm.value.employmentStatus === "Yes"
            ? true
            : false,
        employerName: this.formService.employmentForm.value.employerName,
        employmentStartDate: this.formService.employmentForm.value.startDate,
        employmentPosition: this.formService.employmentForm.value.position,
        hourlyPay: Number(this.formService.employmentForm.value.hourlypay),
        isCurrentlyWorkingForEmployer:
          this.formService.employmentForm.value.isCurrentlyWorkingForEmployer,
      };
      this.isSubmittingEmployment = true;
      this.applicationService.putEmploymentAndExperience(payload).subscribe({
        next: (response) => {
          this.isSubmittingEmployment = false;
          this.toastService.success("employment info submited");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error(" submission failed");
          console.error(error);
          this.isSubmittingEmployment = false;
        },
      });
    }
  }

  private putCitizenShip(form: any) {
    if (form === this.formService.citizenshipForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        countryOfBirth: this.formService.citizenshipForm.value.countryOfBirth,
        isUSCitizen:
          this.formService.citizenshipForm.value.usCitizen === "Yes"
            ? true
            : false,
        countryOfCitizenship:
          this.formService.citizenshipForm.value.countryOfCitizenship,
        isPermanentResident:
          this.formService.citizenshipForm.value.permanentResidentStatus ===
            "Yes"
            ? true
            : false,
        alienNumber: this.formService.citizenshipForm.value.alienNumber,
        hasVisa:
          this.formService.citizenshipForm.value.hasVisa === "Yes"
            ? true
            : false,
        visaStatus:
          this.formService.citizenshipForm.value.qualifiedImmigrant === "Yes"
            ? true
            : false,
        i94Description: this.formService.citizenshipForm.value.I94,
      };
      this.isSubmittingCitizenship = true;
      this.applicationService.putCitizenship(payload).subscribe({
        next: (response) => {
          this.isSubmittingCitizenship = false;
          this.toastService.success("citizenship info submited");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error(" submission failed");
          console.error(error);
          this.isSubmittingCitizenship = false;
        },
      });
    }
  }

  private putDocumentUploads(form: FormGroup): void {
    if (form !== this.formService.documentUploadForm) {
      return;
    }

    const formData = new FormData();
    formData.append(
      "studentApplicationId",
      this.studentApplicationId
        ? this.studentApplicationId
        : sessionStorage.getItem("requestedId")
    );
    formData.append(
      "highSchoolDiplomaUpload",
      form.get("highSchoolTranscript")?.value?.length ? "true" : "false"
    );
    formData.append(
      "collegeTranscriptUpload",
      form.get("collegeTranscript")?.value?.length ? "true" : "false"
    );
    formData.append(
      "governmentIDUpload",
      form.get("Id")?.value?.length ? "true" : "false"
    );
    formData.append(
      "socialSecurityCardUpload",
      form.get("ssn")?.value?.length ? "true" : "false"
    );
    formData.append(
      "cnalicence",
      form.get("cna")?.value?.length ? "true" : "false"
    );
    formData.append(
      "reqbls",
      form.get("bls")?.value?.length ? "true" : "false"
    );
    formData.append(
      "reqdrugscreen",
      form.get("drugScreen")?.value?.length ? "true" : "false"
    );
    formData.append(
      "reqbackgroundcheck",
      form.get("backgroundCheck")?.value?.length ? "true" : "false"
    );
    formData.append(
      "reqhealthscreen",
      form.get("healthScreen")?.value?.length ? "true" : "false"
    );
    formData.append(
      "reqphysicalexam",
      form.get("physicalExam")?.value?.length ? "true" : "false"
    );

    this.files.forEach((fileObj: { file: File; id: string }, index: number) => {
      if (fileObj.file instanceof File) {
        const ext = fileObj.file.name.split(".").pop();
        let fileName = "";

        switch (fileObj.id) {
          case "Id":
            fileName = `ID.${ext}`;
            break;
          case "highSchoolTranscript":
            fileName = `HighSchoolTranscript.${ext}`;
            break;
          case "collegeTranscript":
            fileName = `CollegeTranscript.${ext}`;
            break;
          case "ssn":
            fileName = `SSN.${ext}`;
            break;

          case "cna":
            fileName = `cnalicence.${ext}`;
            break;
          case "bls":
            fileName = `reqbls.${ext}`;
            break;

          case "drugScreen":
            fileName = `reqdrugscreen.${ext}`;
            break;

          case "backgroundCheck":
            fileName = `reqbackgroundcheck.${ext}`;
            break;

          case "healthScreen":
            fileName = `reqhealthscreen.${ext}`;
            break;

          case "physicalExam":
            fileName = `reqphysicalexam.${ext}`;
            break;

          default:
            fileName = `${fileObj.id}.${ext}`;
        }

        formData.append("files", fileObj.file, fileName);
        formData.append("fileNames", fileName);
      } else {
        console.error(`Invalid file at index ${index}:`, fileObj.file);
      }
    });

    // Call service
    this.isSubmittingDocuments = true;
    this.applicationService.putDocumentUploads(formData).subscribe({
      next: (response) => {
        this.isSubmittingDocuments = false;
        this.toastService.success("Documents have been submitted successfully");
        this.files = [];
        this.stepper.next();
      },
      error: (error) => {
        this.isSubmittingDocuments = false;
        this.toastService.error("Submission failed");
        console.error("Submission error details:", error);
        this.files = [];
      },
    });
  }

  private putBackgroundInfo(form: any) {
    if (form === this.formService.backgroundInfoForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        hasCriminalOffense:
          this.formService.backgroundInfoForm.value.criminalHistory === "Yes"
            ? true
            : false,
        hasHealthcareViolation:
          this.formService.backgroundInfoForm.value.healthcareViolation ===
            "Yes"
            ? true
            : false,
        hasDisciplinaryActions:
          this.formService.backgroundInfoForm.value.disciplinaryActions ===
            "Yes"
            ? true
            : false,
        hasRevokedPrivileges:
          this.formService.backgroundInfoForm.value.credentialActions === "Yes"
            ? true
            : false,

        criminalOffenseDescription:
          this.formService.backgroundInfoForm.value.reasonOne,
        healthcareViolationDescription:
          this.formService.backgroundInfoForm.value.reasonTwo,
        disciplinaryActionsDescription:
          this.formService.backgroundInfoForm.value.reasonThree,
        revokedPrivilegesDescription:
          this.formService.backgroundInfoForm.value.reasonFour,
      };

      this.isSubmittingBackground = true;
      this.applicationService.putBackgroundInfo(payload).subscribe({
        next: (response) => {
          this.isSubmittingBackground = false;
          this.toastService.success("Background info submited");
          this.stepper.next();
        },
        error: (error) => {
          this.toastService.error(" submission failed");
          console.error(error);
          this.isSubmittingBackground = false;
        },
      });
    }
  }

  private putCertificateAgreement(form: any) {
    if (form === this.formService.certificationForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        consentToBackgroundCheck:
          this.formService.certificationForm.value.toggleone === "Yes"
            ? true
            : false,
        consentToBackgroundCheckDescription:
          this.formService.certificationForm.value.reasonOne,
        consentToDrugTesting:
          this.formService.certificationForm.value.toggletwo === "Yes"
            ? true
            : false,
        consentToDrugTestingDescription:
          this.formService.certificationForm.value.reasonTwo,
        consentToProvideLegalRightToWork:
          this.formService.certificationForm.value.togglethree === "Yes"
            ? true
            : false,
        consentToProvideLegalRightToWorkDescription:
          this.formService.certificationForm.value.reasonThree,
        agreementToPolicies:
          this.formService.certificationForm.value.togglefour === "Yes"
            ? true
            : false,
        agreementToPoliciesDescription:
          this.formService.certificationForm.value.reasonFour,
        consentToFalseInformation:
          this.formService.certificationForm.value.togglefive === "Yes"
            ? true
            : false,
        consentToFalseInformationDescription:
          this.formService.certificationForm.value.reasonFive,
        consentToClinicalImmunization:
          this.formService.certificationForm.value.togglesix === "Yes"
            ? true
            : false,
        consentToClinicalImmunizationDescription:
          this.formService.certificationForm.value.reasonSix,
      };
      this.isSubmittingCertificateAgreement = true;
      this.applicationService.putCertificateAgreement(payload).subscribe({
        next: (response) => {
          this.toastService.success("Agreement info submited");
          this.stepper.next();
          this.isSubmittingCertificateAgreement = false;
        },
        error: (error) => {
          this.toastService.error(" submission failed");
          console.error(error);
          this.isSubmittingCertificateAgreement = false;
        },
      });
    }
  }

  private putStatementOfUnderstanding(form: any) {
    if (form === this.formService.statementOfUnderstandingForm) {
      const payload = {
        studentApplicationId: this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId"),
        isTermsAndConditions:
          this.formService.statementOfUnderstandingForm.value
            ?.isTermsAndConditions,
      };
      this.isSubmittingUnderstanding = true;
      this.applicationService.putStatementOfUnderstanding(payload).subscribe({
        next: (res) => {
          this.toastService.success(res.statusDescription, "success");
          this.stepper.next();
          this.isSubmittingUnderstanding = false;
        },
        error: (err) => {
          this.toastService.error("submission failed ");
          this.isSubmittingUnderstanding = false;
        },
      });
    }
  }

  private putApplicantSignature(form: any) {
    if (form === this.formService.signatureForm) {
      const invalidIndex = this.setInvalidFormStep();

      if (invalidIndex !== -1) {
        console.warn(`Step ${invalidIndex + 1} is invalid.`);
        return;
      }
      const formData = new FormData();

      formData.append(
        "studentApplicationId",
        this.studentApplicationId
          ? this.studentApplicationId
          : sessionStorage.getItem("requestedId")
      );
      formData.append(
        "date",
        this.formService.signatureForm.get("signatureDate")?.value || ""
      );

      const signatureFile =
        this.formService.signatureForm.get("signature")?.value;

      if (signatureFile) {
        if (signatureFile instanceof File) {
          formData.append("files", signatureFile, signatureFile.name);
        } else if (signatureFile instanceof Blob) {
          formData.append("files", signatureFile, "signature.png");
        }
      }

      this.isSubmittingSignature = true;
      this.applicationService.putApplicantSignature(formData).subscribe({
        next: (response) => {
          this.isSubmittingSignature = false;
          this.sweetAlert.success(response.statusDescription, "success");
          sessionStorage.removeItem("requestedId");
          setTimeout(() => {
            this.router.navigateByUrl("/student-dashboard/welcome");
          }, 2000);
        },
        error: (error) => {
          this.isSubmittingSignature = false;
          this.sweetAlert.error(error, "error");
          console.error("Submission error details:", error);
        },
        complete: () => { },
      });
    }
  }

  private getAllCountries() {
    this.applicationService.getAllCountries().subscribe((res) => {
      this.countries = [];
      res.data.forEach((element: any) => {
        this.countries.push(element.country);
      });
    });
  }

  // private helper functions
  // private updateSignatureControls(): void {
  //   const form = this.formService.signatureForm;
  //   const signatureControl = form.get("signature");
  //   const fullnameControl = form.get("fullname");

  //   signatureControl?.valueChanges.subscribe((signature) => {
  //     if (signature) {
  //       // Signature added → clear fullname
  //       this.updateFormControlValidators(form, ["fullname"], "clear");
  //     } else {
  //       // Signature removed → restore fullname validation
  //       this.updateFormControlValidators(
  //         form,
  //         ["fullname"],
  //         "set",
  //         Validators.required
  //       );
  //     }
  //   });

  //   fullnameControl?.valueChanges.subscribe((name) => {
  //     if (name) {
  //       // Name typed → clear signature
  //       this.updateFormControlValidators(form, ["signature"], "clear");
  //     } else {
  //       // Name cleared → restore signature validation
  //       this.updateFormControlValidators(
  //         form,
  //         ["signature"],
  //         "set",
  //         Validators.required
  //       );
  //     }
  //   });
  // }

  private initializeSubscriptions(): void {
    // Program selection subscription

    this.programSubscription = this.formService.programSelectionForm
      .get("schedule")
      ?.valueChanges.subscribe((selectedProgram) => {
        if (selectedProgram) {
          this.onOptionSelected(selectedProgram);
        } else {
          // Clear dependent fields if program is deselected
          this.clearDependentFields();
        }
      });

    this.scheduleSubscription = this.formService.programSelectionForm
      .get("selectProgram")
      ?.valueChanges.subscribe((selectedSchedule) => {
        if (selectedSchedule) {
          this.formService.programSelectionForm.get('startDate')?.setValue(null)
          this.formService.programSelectionForm.get('startDate')?.updateValueAndValidity()
        } else {
          // Clear dependent fields if program is deselected
          this.clearDependentFields();
        }
      });

    this.formService.citizenshipForm
      .get("usCitizen")
      ?.valueChanges.subscribe((value) => {
        this.onToggleCitizenship(value);
      });

    this.formService.citizenshipForm
      .get("permanentResidentStatus")
      ?.valueChanges.subscribe((value) => {
        this.onTogglePermanentResident(value);
      });

    this.formService.citizenshipForm
      .get("qualifiedImmigrant")
      ?.valueChanges.subscribe((value) => {
        this.onToggleQualifiedImmigrant(value);
      });

    this.formService.signatureForm
      .get("signature")
      ?.valueChanges.subscribe((signature) => {
        const fullnameControl = this.formService.signatureForm.get("fullname");

        if (signature) {
          // Signature added → clear fullname
          fullnameControl?.clearValidators();
          fullnameControl?.updateValueAndValidity({ emitEvent: false });
        } else {
          // Signature removed → restore fullname validation
          fullnameControl?.setValidators(Validators.required);
          fullnameControl?.updateValueAndValidity({ emitEvent: false });
        }
      });

    this.formService.signatureForm
      .get("fullname")
      ?.valueChanges.subscribe((name) => {
        const signatureControl =
          this.formService.signatureForm.get("signature");

        if (name) {
          // Name typed → clear signature
          signatureControl?.clearValidators();
          signatureControl?.updateValueAndValidity({ emitEvent: false });
        } else {
          // Name cleared → restore signature validation
          signatureControl?.setValidators(Validators.required);
          signatureControl?.updateValueAndValidity({ emitEvent: false });
        }
      });
  }

  private setupFormListeners(): void {
    // Listen to schedule changes
    this.formService.programSelectionForm
      .get("schedule")
      ?.valueChanges.pipe(
        distinctUntilChanged(),
        filter((scheduleId) => scheduleId !== null && scheduleId !== undefined),
        tap((scheduleId) => console.log())
      )
      .subscribe((scheduleId) => {
        const selectedProgram =
          this.formService.programSelectionForm.get("selectProgram")?.value;

        if (selectedProgram?.id && scheduleId.id) {
          this.fetchProgramDates(selectedProgram.id, scheduleId.id);
        }
      });

    // Also listen to program changes in case schedule is already selected
    this.formService.programSelectionForm
      .get("selectProgram")
      ?.valueChanges.pipe(
        distinctUntilChanged(),
        filter((program) => program !== null && program !== undefined),
        tap((program) => console.log())
      )
      .subscribe((program) => {
        const scheduleId =
          this.formService.programSelectionForm.get("schedule")?.value;

        if (program?.id && scheduleId?.id) {
          this.fetchProgramDates(program.id, scheduleId?.id);
        }
      });
  }

  private scrollToPosition(position: "top" | "bottom" = "top"): void {
    // Scroll the entire window
    const scrollValue = position === "top" ? 0 : document.body.scrollHeight;
    window.scrollTo({ top: scrollValue, behavior: "smooth" });

    // Scroll the stepper container if it exists and is scrollable
    if (this.stepperContainer?.nativeElement) {
      const container = this.stepperContainer.nativeElement;
      const containerScrollValue =
        position === "top" ? 0 : container.scrollHeight;
      container.scrollTo({ top: containerScrollValue, behavior: "smooth" });
    }

    // Scroll the closest scrollable parent of the active step
    // setTimeout(() => {
    const activeStep = document.querySelector('mat-step[aria-selected="true"]');
    if (activeStep) {
      this.scrollElementToPosition(activeStep, position);
    }
    // }, 100);
  }

  private scrollElementToPosition(
    element: Element,
    position: "top" | "bottom"
  ): void {
    let scrollParent = this.findScrollParent(element);

    while (scrollParent) {
      const scrollValue = position === "top" ? 0 : scrollParent.scrollHeight;
      scrollParent.scrollTo({ top: scrollValue, behavior: "smooth" });
      scrollParent = this.findScrollParent(scrollParent.parentElement);
    }
  }

  private findScrollParent(element: any): any {
    if (!element) return null;

    const style = window.getComputedStyle(element);
    const isScrollable =
      style.overflowY === "auto" || style.overflowY === "scroll";

    if (isScrollable && element.scrollHeight > element.clientHeight) {
      return element;
    }

    return this.findScrollParent(element.parentElement);
  }
  private clearDependentFields(): void {
    this.formService.programSelectionForm.patchValue(
      {
        schedule: null,
        startDate: null,
      }
      // { emitEvent: false }
    );
    // this.filteredScheduleTypes = [];
    this.filteredProgramDates = [];
  }

  private convertToHttps(url: any) {
    if (url.startsWith("http://")) {
      return url.replace("http://", "https://");
    } else {
      return url;
    }
  }
  private getFileExtension(mimeType: string): string {
    const map: Record<string, string> = {
      "application/pdf": "pdf",
      "image/png": "png",
      "image/jpeg": "jpg",
      "application/msword": "doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
    };
    return map[mimeType]; // fallback
  }
  private goBack() {
    this.location.back();
  }

  private GetStateFromZipCode(zipcode: any, item: any) {
    this.applicationService.GetStateFromZipcode(zipcode).subscribe({
      next: (response) => {
        if (item === "zipcode") {
          this.formService.personalInfoForm
            .get("city")
            ?.setValue(response.places[0]["place name"]);
          this.formService.personalInfoForm
            .get("state")
            ?.setValue(response.places[0]["state abbreviation"]);
        } else if (item === "pzipcode") {
          this.formService.personalInfoForm
            .get("permanentCity")
            ?.setValue(response.places[0]["place name"]);
          this.formService.personalInfoForm
            .get("permanentState")
            ?.setValue(response.places[0]["state abbreviation"]);
        }
        return response;
      },
      error: (error) => {
        const errorMessage =
          error.errors?.[0]?.defaultUserMessage || "Zipcode Not Found.";
        this.toastService.error(errorMessage);
        return error;
      },
    });
  }

  private getFormGroupsFromStepper() {
    const formGroups: FormGroup[] = [];
    if (this.stepper && this.stepper.steps) {
      this.stepper.steps.forEach((step) => {
        const formGroup = step.stepControl as FormGroup;
        if (formGroup) {
          formGroups.push(formGroup);
        }
      });
    }
    return formGroups;
  }

  private setInvalidFormStep(): number {
    const formGroups = this.getFormGroupsFromStepper();
    formGroups.forEach((form) => form.markAllAsTouched());

    const invalidIndex = formGroups.findIndex((form) => form.invalid);
    if (invalidIndex !== -1) {
      this.stepper.selectedIndex = invalidIndex;

      document
        .querySelector("mat-stepper")
        ?.scrollIntoView({ behavior: "smooth" });

      return invalidIndex;
    }

    return -1;
  }

  private generateYears(): void {
    const currentYear = new Date().getFullYear();
    this.years = [];

    for (let i = 0; i < 55; i++) {
      const year = String(currentYear - i);
      this.years.push(year);
    }
  }

  private updateFormControlValidators(
    form: FormGroup,
    controls: string[],
    action: "set" | "clear",
    validator?: ValidatorFn | ValidatorFn[],
    valuesToPatch?: { [key: string]: any } // Optional values to patch
  ) {
    controls.forEach((controlName) => {
      const control = form.get(controlName);
      if (control) {
        if (action === "set" && validator) {
          control.setValidators(validator);
        } else if (action === "clear") {
          control.clearValidators();
          control.setValue(null);
          control.markAsPristine();
          control.markAsUntouched();
        }

        if (valuesToPatch && valuesToPatch[controlName] !== undefined) {
          control.patchValue(valuesToPatch[controlName]);
        }

        // control.markAsTouched();
        control.updateValueAndValidity();
      } else {
        console.error(
          `FormControl '${controlName}' not found in the provided form.`
        );
      }
    });
  }

  private logInvalidControls(form: FormGroup) {
    Object.keys(form.controls).forEach((controlName) => {
      const control = form.get(controlName);
      if (control && control.invalid && (control.dirty || control.touched)) {
      }
    });
  }

  private toggleFieldValidation(fieldName: string, isRequired: boolean) {
    const control = this.formService.backgroundInfoForm.get(fieldName);
    if (control) {
      if (isRequired) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  private toggleCertFieldValidation(fieldName: string, isRequired: boolean) {
    const control = this.formService.certificationForm.get(fieldName);
    if (control) {
      if (isRequired) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  private clearPatchedValues() {
    const formGroups = this.getFormGroupsFromStepper();
    formGroups.forEach((formGroup) => {
      formGroup.reset();
    });
  }

  private patchStepForms(form: FormGroup, dataset: any) {
    console.log("<<Start of program info patch>>");
    if (form === this.formService.programInfoForm) {
      this.formService.programInfoForm.patchValue({
        programTitle: dataset.programTitle,
        //  programInitial: dataset.programInitial,
        completionAward: dataset.completionAward,
        startDate: dataset.startDate,
        endDate: dataset.endDate,
        startTime: dataset.startTime,
        endTime: dataset.endTime,
        programDuration: dataset.programDuration,
        // programDurationWeeks: res.programDurationWeeks,
        // programDurationMonths: res.programDurationMonths,
      });
      this.patchClassDays(dataset.classDays);
    }
    console.log("<<Start of program info patch>>");
  }
  private patchClassDays(classDays: ClassDays[]) {
    if (Array.isArray(classDays)) {
      const dayMap: { [key: string]: string } = {
        MON: "monday",
        TUE: "tuesday",
        WEN: "wednesday",
        THUR: "thursday",
        FRI: "friday",
        SAT: "saturday",
        SUN: "sunday",
        "ONLINE FLEX": "onlineFlex",
        "ONLINE HYBRID FLEX": "onlineHybridFlex",
      };

      classDays.forEach((dayObj) => {
        const controlName = dayMap[dayObj.day as keyof typeof dayMap];
        if (controlName) {
          const control = this.formService.programInfoForm
            .get("classDays")
            ?.get(controlName);
          if (control) {
            control.setValue(dayObj.value);
          }
        }
      });
    } else {
      console.warn("Expected classDays to be an array but got:", classDays);
    }
  }

  private patchFormControls() {
    if (!this.StudentApplicationData) {
      console.error("StudentApplicationData is undefined");
      return;
    }

    // Helper function to convert boolean to Yes/No strings
    const booleanToYesNo = (value: boolean | null): string => {
      if (value === null) return ""; // Handle null case
      return value ? "Yes" : "No";
    };
    const startDate = moment(
      this.StudentApplicationData?.desiredStartDate ||
      this.applicationData?.desiredStartDate
    ).format("MM/DD/YYYY");
    const scheduleId = this.StudentApplicationData?.scheduleTypeId;
    const scheduleName = this.StudentApplicationData?.classSchedule;

    this.formService.programSelectionForm.patchValue({
      selectProgram: {
        id: this.StudentApplicationData?.programId,
        programName: this.StudentApplicationData?.programApplied,
      },
      schedule: {
        id: scheduleId,
        name: scheduleName,
      }, // Ensure this matches the expected value type
      startDate: {
        id: this.StudentApplicationData?.programScheduleId,
        startDate: startDate,
      },
      reasonForApplication: this.StudentApplicationData?.reasonForApplication,
    });
    this.onSelectProgram(
      this.formService.programSelectionForm?.get("selectProgram")?.value
    );
    if (this.StudentApplicationData?.applicationStatus) {
    }

    this.formService.personalInfoForm.patchValue({
      firstName: this.StudentApplicationData?.firstName,
      lastName: this.StudentApplicationData?.lastName,
      middleName: this.StudentApplicationData?.middleName,
      dateOfBirth: this.StudentApplicationData?.dob,
      ssn: this.StudentApplicationData?.ssn,
      email: this.StudentApplicationData?.emailAddress,
      phoneNumber: this.StudentApplicationData?.mobileNumber,
      streetAddress: this.StudentApplicationData?.mailStreetAddress,
      city: this.StudentApplicationData?.mailCity,
      state: this.StudentApplicationData?.mailState,
      zipCode: this.StudentApplicationData?.mailZipCode,
      messageConsent: this.StudentApplicationData.consent,
      permanentStreetAddress:
        this.StudentApplicationData?.phyStreetAddress ||
        this.StudentApplicationData?.mailStreetAddress,
      permanentCity:
        this.StudentApplicationData?.phyCity ||
        this.StudentApplicationData?.mailCity,
      permanentState:
        this.StudentApplicationData?.phyState ||
        this.StudentApplicationData?.mailState,
      permanentZipCode:
        this.StudentApplicationData?.phyZipCode ||
        this.StudentApplicationData?.mailZipCode,
    });

    this.formService.emergencyContactForm.patchValue({
      emergencyFirstName: this.StudentApplicationData?.emergencyFirstName,
      emergencyMiddleName: this.StudentApplicationData?.emergencyMiddleName,
      emergencyLastName: this.StudentApplicationData?.emergencyLastName,
      emergencyEmailAddress: this.StudentApplicationData?.emergencyEmail,
      emergencyPhoneNumber: this.StudentApplicationData?.emergencyPhone,
      fulladdress: this.StudentApplicationData?.fullAddress,
      relationship: this.StudentApplicationData?.relationship,
    });

    this.formService.ethnicityForm.patchValue({
      gender: this.StudentApplicationData?.gender,
      ethnicity: this.StudentApplicationData?.ethnicRace,
    });

    this.formService.disabilityForm.patchValue({
      disabilityPresence: booleanToYesNo(
        this.StudentApplicationData?.hasDisability
      ),
      disability: this.StudentApplicationData?.disabilityDescription,
      typeOfAccommodation: this.StudentApplicationData?.accommodationRequest,
    });
    this.onToggleDisability(
      this.formService.disabilityForm?.get("disabilityPresence")?.value
    );

    const isAnyCourseNo =
      this.StudentApplicationData?.humanAnatomyAndPhysiology1Course ===
        "Human Anatomy and Physiology I"
        ? true
        : false ||
          this.StudentApplicationData?.humanAnatomyAndPhysiology2Course ===
          "Human Anatomy and Physiology II"
          ? true
          : false ||
            this.StudentApplicationData?.medicalTerminologyCourse ===
            "Medical Terminology"
            ? true
            : false ||
              this.StudentApplicationData?.pharmacologyOfNursingCourse ===
              "Pharmacology of Nursing"
              ? true
              : false;

    this.formService.practicalNursingForm.patchValue({
      transcript: this.StudentApplicationData?.transcript || null,

      humanAnatomyAndPhysiology1: booleanToYesNo(
        this.StudentApplicationData?.humanAnatomyAndPhysiology1
      ),
      humanAnatomyAndPhysiology1Course:
        this.StudentApplicationData?.humanAnatomyAndPhysiology1Course ===
          "Human Anatomy and Physiology I"
          ? true
          : false,

      humanAnatomyAndPhysiology2: booleanToYesNo(
        this.StudentApplicationData?.humanAnatomyAndPhysiology2
      ),
      humanAnatomyAndPhysiology2Course:
        this.StudentApplicationData?.humanAnatomyAndPhysiology2Course ===
          "Human Anatomy and Physiology II"
          ? true
          : false,

      medicalTerminology: booleanToYesNo(
        this.StudentApplicationData?.medicalTerminology
      ),
      medicalTerminologyCourse:
        this.StudentApplicationData?.medicalTerminologyCourse ===
          "Medical Terminology"
          ? true
          : false,

      pharmacologyOfNursing: booleanToYesNo(
        this.StudentApplicationData?.pharmacologyOfNursing
      ),
      pharmacologyOfNursingCourse:
        this.StudentApplicationData?.pharmacologyOfNursingCourse ===
          "Pharmacology of Nursing"
          ? true
          : false,
      preNursing: isAnyCourseNo,

      refresher: this.StudentApplicationData?.refresher,
      refresherCourse: this.StudentApplicationData?.refresherCourse,
    });
    this.onCourseSelectionChange();

    this.toggleRefresherCheckBox = this.StudentApplicationData?.refresher;

    this.togglePreNursingChekBox = isAnyCourseNo;
    this.onPreNursingCheck(this.togglePreNursingChekBox);

    this.formService.studentVerificationForm.patchValue({
      firstTimeProgram: booleanToYesNo(
        this.StudentApplicationData?.isFirstTimeStudentAtMedNoc
      ),
      retakingProgram: booleanToYesNo(
        this.StudentApplicationData?.isRetakingProgramFromAnotherSchool
      ),
      pastProgram: booleanToYesNo(
        this.StudentApplicationData?.hasTakenOtherProgramsAtMedNoc
      ),
    });

    this.formService.studentSourceForm.patchValue({
      source: this.StudentApplicationData?.sourceOfReferral,
      studentSourceText: this.StudentApplicationData?.studentSourceText,
    });
    this.onSelectSource(this.StudentApplicationData?.sourceOfReferral);
    this.formService.usMilitaryRecordForm.patchValue({
      currentMilitaryOrVeteran: booleanToYesNo(
        this.StudentApplicationData?.isMilitaryOrVeteran
      ),
      militaryBranch: this.StudentApplicationData?.militaryBranch,
      startDate: this.StudentApplicationData?.militaryEntryDate,
      endDate: this.StudentApplicationData?.militaryDischargeDate,
      dischargeStatus: this.StudentApplicationData?.militaryAchievement,
    });
    this.onToggleMilitary(
      this.formService.usMilitaryRecordForm?.get("currentMilitaryOrVeteran")
        ?.value
    );

    this.formService.educationalBackgroundForm.patchValue({
      highestEducation: this.StudentApplicationData?.highestEducationLevel,
      canReadWriteEnglish: booleanToYesNo(
        this.StudentApplicationData?.canReadWriteEnglish
      ),
      highSchoolName: this.StudentApplicationData?.highSchoolName,
      highSchoolGraduationYear:
        this.StudentApplicationData?.highSchoolGraduationYear,
      graduatedCollege: booleanToYesNo(
        this.StudentApplicationData?.didGraduateCollege
      ),
      collegeName: this.StudentApplicationData?.collegeName,
      major: this.StudentApplicationData?.collegeMajor,
      gpa: this.StudentApplicationData?.collegeGPA,
      collegeGraduationMonthYear:
        this.StudentApplicationData?.collegeGraduationDate,
      graduatedUniversity: booleanToYesNo(
        this.StudentApplicationData?.didGraduateUniversity
      ),
      universityName: this.StudentApplicationData?.universityName,
      universityMajor: this.StudentApplicationData?.universityMajor,
      universityGpa: this.StudentApplicationData?.universityGPA,
      universityGraduationMonthYear:
        this.StudentApplicationData?.universityGraduationDate,
    });

    this.onSelectElementary(
      this.formService.educationalBackgroundForm?.get("highestEducation")?.value
    );
    this.onToggleCollegeGraduant(
      this.formService.educationalBackgroundForm?.get("graduatedCollege")?.value
    );
    // this.onToggleVarsityGraduant(
    //   this.formService.educationalBackgroundForm?.get("graduatedUniversity")
    //     ?.value
    // );
    this.onToggleVarsityIfCollege(
      this.formService.educationalBackgroundForm?.get("graduatedUniversity")
        ?.value
    );

    this.formService.employmentForm.patchValue({
      employmentStatus: booleanToYesNo(
        this.StudentApplicationData?.isCurrentlyEmployed
      ),
      employerName: this.StudentApplicationData?.employerName,
      startDate: this.StudentApplicationData?.employmentStartDate,
      position: this.StudentApplicationData?.employmentPosition,
      hourlypay: this.StudentApplicationData?.hourlyPay,
      isCurrentlyWorkingForEmployer:
        this.StudentApplicationData?.isCurrentlyWorkingForEmployer,
    });
    this.onToggleEmploymentStatus(
      this.formService.employmentForm?.get("employmentStatus")?.value
    );

    this.formService.citizenshipForm.patchValue({
      countryOfBirth: this.StudentApplicationData?.countryOfBirth,
      usCitizen: booleanToYesNo(this.StudentApplicationData?.isUSCitizen),
      countryOfCitizenship: this.StudentApplicationData?.countryOfCitizenship,
      permanentResidentStatus: booleanToYesNo(
        this.StudentApplicationData?.isPermanentResident
      ),
      alienNumber: this.StudentApplicationData?.alienNumber,
      // qualifiedImmigrant: booleanToYesNo(
      //   this.StudentApplicationData?.qualifiedImmigrant
      // ),
      qualifiedImmigrant: booleanToYesNo(
        this.StudentApplicationData?.visaStatus
      ),
      hasVisa: booleanToYesNo(this.StudentApplicationData?.hasVisa),
      I94: this.StudentApplicationData.i94Description,
    });
    this.onToggleCitizenship(
      this.formService.citizenshipForm.get("usCitizen")?.value
    );
    this.onTogglePermanentResident(
      this.formService.citizenshipForm.get("permanentResidentStatus")?.value
    );
    if (
      this.formService.citizenshipForm.get("permanentResidentStatus")?.value ===
      "Yes"
    ) {
      this.permanentResident = true;
    } else {
      this.permanentResident = false;
    }
    if (
      this.formService.citizenshipForm.get("permanentResidentStatus")?.value ===
      "No"
    ) {
      this.notResident = true;
    } else {
      this.notResident = false;
    }

    this.onToggleQualifiedImmigrant(
      this.formService.citizenshipForm.get("qualifiedImmigrant")?.value
    );
    this.formService.backgroundInfoForm.patchValue({
      criminalHistory: booleanToYesNo(
        this.StudentApplicationData?.hasCriminalOffense
      ),
      healthcareViolation: booleanToYesNo(
        this.StudentApplicationData?.hasHealthcareViolation
      ),
      disciplinaryActions: booleanToYesNo(
        this.StudentApplicationData?.hasDisciplinaryActions
      ),
      credentialActions: booleanToYesNo(
        this.StudentApplicationData?.hasRevokedPrivileges
      ),
      reasonOne: this.StudentApplicationData?.criminalOffenseDescription,
      reasonTwo: this.StudentApplicationData?.healthcareViolationDescription,
      reasonThree: this.StudentApplicationData?.disciplinaryActionsDescription,
      reasonFour: this.StudentApplicationData?.revokedPrivilegesDescription,
    });
    this.onToggleBackgroundInfo(
      "Q1",
      this.formService.backgroundInfoForm?.get("criminalHistory")?.value ===
        "Yes"
        ? "Yes"
        : "No"
    );
    this.onToggleBackgroundInfo(
      "Q2",
      this.formService.backgroundInfoForm?.get("healthcareViolation")?.value ===
        "Yes"
        ? "Yes"
        : "No"
    );
    this.onToggleBackgroundInfo(
      "Q3",
      this.formService.backgroundInfoForm?.get("disciplinaryActions")?.value ===
        "Yes"
        ? "Yes"
        : "No"
    );
    this.onToggleBackgroundInfo(
      "Q4",
      this.formService.backgroundInfoForm?.get("credentialActions")?.value ===
        "Yes"
        ? "Yes"
        : "No"
    );

    this.formService.certificationForm.patchValue({
      toggleone: booleanToYesNo(
        this.StudentApplicationData?.consentToBackgroundCheck
      ),
      toggletwo: booleanToYesNo(
        this.StudentApplicationData?.consentToDrugTesting
      ),
      togglethree: booleanToYesNo(
        this.StudentApplicationData?.consentToProvideLegalRightToWork
      ),
      togglefour: booleanToYesNo(
        this.StudentApplicationData?.agreementToPolicies
      ),
      togglefive: booleanToYesNo(
        this.StudentApplicationData?.consentToFalseInformation
      ),
      togglesix: booleanToYesNo(
        this.StudentApplicationData?.consentToClinicalImmunization
      ),

      reasonOne:
        this.StudentApplicationData?.consentToBackgroundCheckDescription,
      reasonTwo: this.StudentApplicationData?.consentToDrugTestingDescription,
      reasonThree:
        this.StudentApplicationData
          ?.consentToProvideLegalRightToWorkDescription,
      reasonFour: this.StudentApplicationData?.agreementToPoliciesDescription,
      reasonFive:
        this.StudentApplicationData?.consentToFalseInformationDescription,
      reasonSix:
        this.StudentApplicationData?.consentToClinicalImmunizationDescription,
    });

    this.onToggleCertification(
      "Q1",
      this.formService.certificationForm?.get("toggleone")?.value === "No"
        ? "No"
        : "Yes"
    );
    this.onToggleCertification(
      "Q2",
      this.formService.certificationForm?.get("toggletwo")?.value === "No"
        ? "No"
        : "Yes"
    );
    this.onToggleCertification(
      "Q3",
      this.formService.certificationForm?.get("togglethree")?.value === "No"
        ? "No"
        : "Yes"
    );
    this.onToggleCertification(
      "Q4",
      this.formService.certificationForm?.get("togglefour")?.value === "No"
        ? "No"
        : "Yes"
    );
    this.onToggleCertification(
      "Q5",
      this.formService.certificationForm?.get("togglefive")?.value === "No"
        ? "No"
        : "Yes"
    );
    this.onToggleCertification(
      "Q6",
      this.formService.certificationForm?.get("togglesix")?.value === "No"
        ? "No"
        : "Yes"
    );
    this.onToggleCertification(
      "Q7",
      this.formService.certificationForm?.get("toggleseven")?.value === "No"
        ? "No"
        : "Yes"
    );

    this.formService.statementOfUnderstandingForm.patchValue({
      isTermsAndConditions: this.StudentApplicationData?.isTermsAndConditions,
    });
    // updating document Validators
    if (this.StudentApplicationData?.noDocumentsRequired === true) {
      // Clear all document validators
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["cna", "ssn", "Id", "highSchoolTranscript", "collegeTranscript"],
        "clear"
      );
      console.log("<updated validators for no docs>>");
      this.noDocRequired = true;
    } else {
      // Set validators based on individual flags
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["Id"],
        this.StudentApplicationData?.reqGovPhotoId === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["collegeTranscript"],
        this.StudentApplicationData?.reqCollegeTrans === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["highSchoolTranscript"],
        this.StudentApplicationData?.reqHighSchoolDipGed === true
          ? "set"
          : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["ssn"],
        this.StudentApplicationData?.reqSSNDoc === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["cna"],
        this.StudentApplicationData?.reqCNALicense === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["bls"],
        this.StudentApplicationData?.reqBLS === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["drugScreen"],
        this.StudentApplicationData?.reqDrugScreen === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["backgroundCheck"],
        this.StudentApplicationData?.reqBackgroundCheck === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["healthScreen"],
        this.StudentApplicationData?.reqHealthScreen === true ? "set" : "clear",
        Validators.required
      );
      this.updateFormControlValidators(
        this.formService.documentUploadForm,
        ["physicalExam"],
        this.StudentApplicationData?.reqPhysicalExam === true ? "set" : "clear",
        Validators.required
      );
      this.noDocRequired = true;
    }
    // patching documents
    this.getUrlDocument(
      this.StudentApplicationData?.highSchoolDiplomaUploadUrl,
      "highSchoolTranscript"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.collegeTranscriptUploadUrl,
      "collegeTranscript"
    );
    this.getUrlDocument(this.StudentApplicationData?.cnaLicenceUrl, "cna");
    this.getUrlDocument(this.StudentApplicationData?.reqBLSUrl, "bls");
    this.getUrlDocument(
      this.StudentApplicationData?.socialSecurityCardUploadUrl,
      "ssn"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.governmentIDUploadUrl,
      "Id"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.transcriptUploadUrl,
      "transcript"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.reqDrugScreenUrl,
      "drugScreen"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.reqBackgroundCheckUrl,
      "backgroundCheck"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.reqHealthScreenUrl,
      "healthScreen"
    );
    this.getUrlDocument(
      this.StudentApplicationData?.reqPhysicalExamUrl,
      "physicalExam"
    );

    if (this.StudentApplicationData) {
      if (this.StudentApplicationData?.date) {
        const dateString = this.StudentApplicationData?.date
          ? this.StudentApplicationData?.date
          : "";
        const date = new Date(dateString);
        const signatureDate = date.toISOString();
        this.formService.signatureForm.patchValue({
          // signature: this.StudentApplicationData?.signature,
          signatureDate: String(signatureDate),
          fullname:
            this.StudentApplicationData?.applicantFullName ||
            [
              this.StudentApplicationData?.firstName,
              this.StudentApplicationData?.middleName,
              this.StudentApplicationData?.lastName,
            ]
              .filter(Boolean)
              .join(" "),
        });
      }
    }
    // if (
    //   this.StudentApplicationData?.signatureUploadId &&
    //   this.StudentApplicationData?.signatureUploadName
    // ) {
    //   this.applicationSignaturePad.patchSignature(
    //     this.StudentApplicationData?.signatureUploadId,
    //     this.StudentApplicationData?.signatureUploadName
    //   );
    // }
  }
}
